import React, { useState } from "react";
import Breadcrumbs from "../layout/breadcrumb";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ProjectHandoverList from "./project-handover-list";
import ProjectHandoverForm from "./project-handover-form";
import DprHeader from '../layout/dprHeader'
import { useLocation } from "react-router-dom";
function ProjectHandover() {
  const [activeTab, setActiveTab] = useState(0); // Track active tab index
const location = useLocation();
    const pro = location.state || {};
  return (
    <>
      {/* Conditional rendering of Breadcrumbs based on the active tab */}
      {activeTab === 0 ? (
        <Breadcrumbs title="Project Handover" menu="Project Handover List" />
      ) : (
        <Breadcrumbs title="Project Handover" menu="Project Handover Form" />
      )}
      <DprHeader project={pro} />
      <div className="row mt-3">
        <Tabs selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}>
          <div className="card p-2">
          
                <TabList>
                  <Tab>Project Handover List</Tab>
                  <Tab>Project Handover Form</Tab>
                </TabList>
             <hr></hr>
          
          
            <TabPanel>
              <ProjectHandoverList />
            </TabPanel>
            <TabPanel>
  <ProjectHandoverForm onCancel={() => setActiveTab(0)} />
</TabPanel>

            </div>
        </Tabs>
      </div>
    </>
  );
}

export default ProjectHandover;
